import { sentencesPerLine } from "./sentences-per-line.js";

export = sentencesPerLine;
